import { DeliveryTypeCategory } from '@/features/orders/constants/app'
import { Order } from '@/features/orders/types/app'

export const isDeliveryOrder = (order: Order) =>
    order.deliveryType.typeCategory === DeliveryTypeCategory.Delivery
